import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { setRegOneAuth, setAuth } from '../../utils/index';
import API from '../../API';
import Cookies from 'js-cookie';


async function postApi(data) {
    try {
        const response = axios.post('/validate_user', data);
        return await response;
    } catch (error) {
        throw error;
    }
}

function* registerOtp(action) {
    try {
        const response = yield call(postApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // Check if this is OTP verification after login (user has email cookie)
            const userEmail = Cookies.get('email');
            if (userEmail) {
                // This is OTP verification after login, use setAuth to mark user as logged in
                setAuth(response.data.data, response.headers);
            } else {
                // This is registration OTP verification, use setRegOneAuth
                setRegOneAuth(response.data.data, response.headers);
            }
            
            yield put({ type: 'POST_REGISTER_OTP_SUCCESS', registerPersonal: response.data });
            yield put({ type: 'STORE_ACTIVE_REG_STEP_SUCCESS', activeStep: 3 });
            yield put({ type: 'STORE_SET_AUTH_SUCCESS', auth: response.data.data });
            // toastr.success('Success', 'You are successfully completed the second step ');
        } else {
            // response.errors.length != 0 && toastr.error('Pegister personal  failed', response.errors[0]);
        }
    } catch (e) {
        // toastr.error('Failed', 'Failed to verify the OTP ');
        yield put({ type: 'POST_REGISTER_OTP_FAILED', error: e.response.data.data.errors[0] });
    }
}

function* registerOtpSaga() {
    yield takeEvery('POST_REGISTER_OTP_REQUESTED', registerOtp);
}

export default registerOtpSaga;